import React from "react";
import {
  Box,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import MultiTagSelector from "./MultiTagSelector";

export default function MiniGameSectionBigbox({ config, onChange, tagsData }) {
  const updateTitle = (value) => {
    onChange({ ...config, title: value });
  };

  const updateSelectFilter = (filterKey, value) => {
    onChange({ ...config, [filterKey]: value });
  };

  const updateShow = (value) => {
    onChange({ ...config, show: value });
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle2">Display</Typography>

      <Box display="flex" gap={2} alignItems="flex-end" flexWrap="wrap">
        {/* Title Input */}
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            display="block"
            mb={0.5}
          >
            Title
          </Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="Enter title"
            value={config.title}
            onChange={(e) => updateTitle(e.target.value)}
          />
        </Box>

        <MultiTagSelector
          config={config}
          tagsData={tagsData}
          updateSelectFilter={updateSelectFilter}
        />

        <FormControl size="small" style={{ minWidth: 80 }}>
          <InputLabel>Show</InputLabel>
          <Select
            value={config.show}
            label="Show"
            onChange={(e) => updateShow(e.target.value)}
          >
            <MenuItem value="5">5</MenuItem>
            <MenuItem value="10">10</MenuItem>
            <MenuItem value="15">15</MenuItem>
            <MenuItem value="20">20</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
}
